/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';

/**
 * Provides a utility hook for clearing grid filters.
 *
 * ```typescript
 *
 * const onClearFilters = useClearFilters(gridRef);
 *
 * ```
 */
export const useClearFilters = gridRef => {
  const onClearFilters = useCallback(() => {
    gridRef?.current?.onClearFilters?.();
  }, [gridRef]);
  return onClearFilters;
};

export default useClearFilters;
